<template>
  <div v-loading="isLoading">
    <el-table
      :data="roles"
      stripe
    >
      <el-table-column
        label="Name"
        prop="name"
      />
      <el-table-column
        label="Description"
        prop="description"
      />
      <el-table-column
        label="Access"
        prop="level"
        width="100"
        :formatter="(row, col, cellValue) => cellValue.access || '-'"
      />
      <el-table-column
        label="Level"
        prop="level"
        :formatter="(row, col, cellValue) => cellValue.description || '-'"
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click.native="editRole(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click.native="deleteRole(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>

    <!-- Edit Form -->
    <RoleEditForm
      ref="roleEditForm"
      :account-id="accountId"
      @saved="loadTable()"
    />
  </div>
</template>

<script>
import RoleEditForm from '@/components/Application/Manage/Account/RoleEditForm'
export default {
  components: {
    RoleEditForm
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      roles: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      isShowDeletePopover: false
    }
  },
  created () {
    this.loadTable()
  },
  mounted () {
    this.actions = [
      {
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.$refs.roleEditForm.role = {}
          this.$refs.roleEditForm.isShowDialog = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.role.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'uuid:asc'
      })
        .then(res => {
          this.roles = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editRole (index, row) {
      this.$refs.roleEditForm.role = row
      this.$refs.roleEditForm.isShowDialog = true
    },
    deleteRole (index, row) {
      this.$confirm('Are you sure to delete this role?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
